import React from 'react'
import { useDrag, useDrop } from 'react-dnd'

const Bank = ({ bank, index, moveBank, showArchiveStatus }) => {
  const ref = React.useRef(null)

  const [{ isDragging }, drag] = useDrag({
    type: 'bank',
    item: { index, bank },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const [, drop] = useDrop({
    accept: 'bank',
    hover(item, monitor) {
      const dragIndex = item.index
      const hoverIndex = index

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect()

      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

      // Determine mouse position
      const clientOffset = monitor.getClientOffset()

      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      // Only perform the move when the mouse has crossed half of the item's height
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }

      // Time to actually perform the action
      moveBank(dragIndex, hoverIndex)

      // Mutate the monitor item here for performance
      item.index = hoverIndex
    },
  })

  drag(drop(ref))

  const onMouseEnter = (e) => {
    e.target.classList.add('hover')
  }

  const onMouseLeave = (e) => {
    e.target.classList.remove('hover')
  }

  const opacity = isDragging ? 0 : 1
  const cursor = isDragging ? 'move' : 'pointer'
  const center = { textAlign: 'center' }

  return (
    <tr
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      key={bank.id}
      style={{ opacity, cursor }}
      className={bank.archived ? 'bank disabled' : 'bank'}
    >
      <td>
        <i className="material-icons draggable">drag_indicator</i>
        {bank.name}
      </td>
      <td style={center}>{bank.count}</td>
      <td style={center}>{bank.initial}</td>
      <td style={center}>{bank.midstream}</td>
      <td style={center}>{bank.wrapup}</td>
      <td style={center}>{bank.meta}</td>
      <td style={center}>{showArchiveStatus(bank)}</td>
      <td style={center}>
        <a href={`/admin/banks/${bank.id}/edit`}>Edit</a>
      </td>
    </tr>
  )
}

export default Bank
